import styled from 'styled-components';
import { Checkbox } from 'components/uikit/Form/Checkbox/Checkbox';
import { FormGridRowBase } from '../../style';
import { AnketaInputMask } from '../../../style';

export const FormGridRow = styled(FormGridRowBase)`
  grid-template-areas: '. p1 p1 p2 p2 ch1 ch1 .';
`;

export const MainProfit = styled(AnketaInputMask)`
  grid-area: p1;
  margin-bottom: 0px;
`;

export const AddedProfit = styled(AnketaInputMask)`
  grid-area: p2;
  margin-bottom: 0px;
`;

export const ProofCheckbox = styled(Checkbox).attrs({ size: 'xs' })`
  grid-area: ch1;
`;
